import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter
} from '@angular/core';
import { MONTHS } from 'src/app/constants/app.constants';
import { TranslatorService } from 'src/app/translator.service';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnChanges {
  @Input() label: string;
  @Input() caption: string;
  @Input() placeholder: string;
  @Input() showLabel = true;
  @Input() showDay = true;
  @Input() error: string;
  @Input() value: string;
  @Input() maxDate: string;
  @Output() change = new EventEmitter<string>();

  day;
  month;
  year;

  dayOptions = new Array(31)
    .fill(undefined)
    .map((v, d) => ({ value: d + 1, label: d + 1 }));

  monthOptions = MONTHS.map((m, i) => ({
  value: i,
  label: this.translatorService.currentLang.toLowerCase() === 'es' ? m.label : m.value
}));

  yearOptions = new Array(100).fill(undefined).map((v, y) => ({
    value: new Date().getFullYear() - y,
    label: new Date().getFullYear() - y
  }));

  constructor( private translatorService: TranslatorService, private cdr: ChangeDetectorRef) {}
  private idiomaSub: Subscription;

 ngOnInit(): void {
    this.generateMonthOptions();
      this.idiomaSub = this.translatorService.onIdiomaCambiado().subscribe(() => {
      this.changeLanguage();
    }); 
}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.value &&
      changes.value.currentValue !== changes.value.previousValue
    ) {
      const today = new Date(this.value || undefined);
      this.day = today.getDate();
      this.month = today.getMonth();
      this.year = today.getFullYear();
    }
  }

  handleChange() {
    var lastDay = new Date(this.year, this.month + 1, 0).getDate();

    if (this.day > lastDay) {
      this.day = lastDay;
    }

    const date = new Date();
    date.setDate(this.day);
    date.setMonth(this.month);
    date.setFullYear(this.year);

    date.setHours(0, 0, 0, 0);

    if (this.day && this.month && this.year) {
      this.change.emit(date.toISOString());
    }
  }

  changeLanguage()
  {
    this.generateMonthOptions();
  }

  private generateMonthOptions() {
  this.monthOptions = MONTHS.map((m, i) => ({
    value: i,
    label: this.translatorService.currentLang.toLowerCase() === 'es' ? m.label : m.value
  }));
  this.cdr.detectChanges();
}

ngOnDestroy(): void {
  if (this.idiomaSub) {
    this.idiomaSub.unsubscribe();
  }
}
}
